<template>
  <div v-if="!loading" class="flex flex-wrap center justify-center items-center white-bg col-12 border-box z1 px3 py2">
    <div v-if="canShowButton" class="flex flex-wrap col-12 center justify-center items-center">
      <div class="flex center justify-center items-center col-12 bold">L'accès à ce billet est bloqué</div>
      <div class="flex center justify-center items-center col-12">Vos paiements ne sont pas à jour. L'accès à ce billet est bloqué.</div>
      <Button :text="buttonText" class="flex center justify-center items-center p1" text-size="h8n" button-color="red-bg" :action="goToModification" />
    </div>
    <div v-else class="flex flex-wrap col-12 center justify-center items-center">
      <div class="flex center justify-center items-center col-12 bold">L'accès à ce billet est bloqué</div>
      <div class="flex center justify-center items-center col-12">Veuillez vous rendre à l'accueil du centre afin de régulariser votre situation.</div>
    </div>
  </div>
  <div v-else class="flex flex-wrap center justify-center items-center col-12 border-box z1 px3 py2">
    <div class="loader"></div>
  </div>
</template>

<script>
import { computed, ref, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Button from '@/components/elements/Button';
import { isInImpersonateModeNotification } from '@/mixins/utils';
import { getInvoicesInfo } from '@/mixins/requests';

export default {
  components: { Button },
  props: {
    billet: {
      type: Object,
      default: null
    }
  },
  setup (props) {
    const loading = ref(true);
    const store = useStore();
    const router = useRouter();
    const invoicesResponse = ref(null);
    const canShowButton = computed(() => invoicesResponse.value && invoicesResponse.value.success && invoicesResponse.value.data && invoicesResponse.value.data.length);

    onBeforeMount(async () => {
      loading.value = true;
      await getInvoicesInfo({ orderUuid: props.billet.order_uuid })
        .then(async r => {
          invoicesResponse.value = r;
        })
        .catch(err => console.log(err));
      loading.value = false;
    });

    const goToModification = async () => {
      store.commit('setLoading', true);
      if (isInImpersonateModeNotification()) {
        store.commit('setLoading', false);
        return;
      }

      if (invoicesResponse.value && invoicesResponse.value.success) {
        const { data } = invoicesResponse.value;
        if (data) {
          const unpaidInvoices = data.filter(i => !i.paid);
          if (unpaidInvoices.length === 1) {
            const { url } = data[0];
            if (url) {
              window.open(
                `${url}`,
                '_blank'
              );
            }
          } else if (unpaidInvoices.length > 1) {
            router.push({ name: 'OrderInvoices', params: { uuid: props.billet.order_uuid } });
          }
        }
      }

      store.commit('setLoading', false);
    };

    const buttonText = computed(() => {
      if (invoicesResponse.value && invoicesResponse.value.success && invoicesResponse.value.data && invoicesResponse.value.data.length) {
        if (invoicesResponse.value.data.length === 1) {
          return 'Payer ma facture';
        }
        return 'Payer mes factures';
      }
      return null;
    });

    return { loading, canShowButton, goToModification, invoicesResponse, buttonText };
  }
};
</script>
